import { __ } from 'bits/intl'

const t = {
  bind: (el, binding) => {
    if (binding.arg) {
      const phrase = binding.value
      const translatedPhrase = __(String(phrase).trim())
      el.setAttribute(binding.arg, translatedPhrase)
    } else {
      const phrase = binding.value || el.textContent
      const translatedPhrase = __(String(phrase).trim())
      el.textContent = translatedPhrase
    }
  },
}

export default t
